import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Widget } from "../NewsAndAnalysis/Analysis/Widget";
import { REPORT_TYPES, HOTSTAR_ID } from "../../constants/app-constant";
import { CustomBSDropdown } from "./../Shared";

export const WidgetWrapper = ({
  widget,
  filteredWidgets,
  user_id,
  history,
  selectedDashboard,
  showTodaysFeedWidget,
  handleTodayFeedWidgeStatus,
  fetchWidgets,
  setWidgetCreationStatus,
  setFilteredWidgets,
  widgets,
  setWidgets,
  enableDownloadFn,
  setGraphRefList,
  filterOption,
}) => {
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const clientId = selectedClient && selectedClient.id;

  const { type, report_type } = widget;

  const [selectedFilter, setSelectedFilter] = useState(
    filterOption && filterOption[0]
  );

  if (
    clientId == HOTSTAR_ID &&
    [
      REPORT_TYPES.SOV_NOA_TREND,
      REPORT_TYPES.SOV_CCM_TREND,
      REPORT_TYPES.SOV_MAV_TREND,
      REPORT_TYPES.SOVNOARanking,
      REPORT_TYPES.SOVCCMRanking,
      REPORT_TYPES.SOVMAVRanking,
    ].indexOf(report_type) >= 0
  ) {
    const optList = Array.isArray(filterOption)
      ? filterOption.filter((el) => el.vertical.indexOf(type) !== -1)
      : [];

    widget.report_type = selectedFilter
      ? selectedFilter.value
      : widget.report_type;

    const renderAnalysisWidget = () => {
      return (
        <CustomBSDropdown
          config={{
            name: "report type",
            options: optList,
          }}
          selectedItem={selectedFilter}
          onSelect={setSelectedFilter}
          hideAllOption
        />
      );
    };

    return (
      <div className="col-md-6" key={widget.id}>
        <Widget
          key={widget.id}
          user_id={user_id}
          widget={widget}
          history={history}
          renderAnalysisWidget={renderAnalysisWidget}
          selectedDashboard={selectedDashboard}
          showTodaysFeedWidget={showTodaysFeedWidget}
          handleTodayFeedWidgeStatus={handleTodayFeedWidgeStatus}
          fetchWidgets={fetchWidgets}
          setWidgetCreationStatus={setWidgetCreationStatus}
          setFilteredWidgets={setFilteredWidgets}
          filteredWidgets={filteredWidgets}
          widgets={widgets}
          setWidgets={setWidgets}
          isDashboardWidget
          enableDownloadFn={enableDownloadFn}
          setGraphRefList={setGraphRefList}
        />
      </div>
    );
  }

  return (
    <div className="col-md-6" key={widget.id}>
      <Widget
        key={widget.id}
        user_id={user_id}
        widget={widget}
        history={history}
        selectedDashboard={selectedDashboard}
        showTodaysFeedWidget={showTodaysFeedWidget}
        handleTodayFeedWidgeStatus={handleTodayFeedWidgeStatus}
        fetchWidgets={fetchWidgets}
        setWidgetCreationStatus={setWidgetCreationStatus}
        setFilteredWidgets={setFilteredWidgets}
        filteredWidgets={filteredWidgets}
        widgets={widgets}
        setWidgets={setWidgets}
        isDashboardWidget
        enableDownloadFn={enableDownloadFn}
        setGraphRefList={setGraphRefList}
      />
    </div>
  );
};
